import { intl } from "../../../config/common";

/**
 * 从本地约定的配置文件读取配置
 */
export const getOamIntlConfigFileContent = () => {
  return intl;
};

/**
 * 语句首字母大写
 */
export const capitalizeFirstWord = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * 每个单词首字母大写
 */
export const capitalizeEveryWord = (str: string) => {
  const words = str.toLowerCase().split(" ");
  const capitalizedWords = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
  return capitalizedWords.join(" ");
};
